/**
 * Distinct `{ value, label }` pairs present in the loaded rows, label-sorted. The basis for every
 * data-derived filter (E2E-24: file type options come from the types actually present, never a
 * fixed list) — a surface's own filter config calls this with its accessors.
 */
export function uniqueOptions(rows, getValue, getLabel) {
    const seen = new Map();
    rows.forEach((row) => {
        const value = getValue(row);
        if (!seen.has(value))
            seen.set(value, getLabel(row));
    });
    return Array.from(seen.entries())
        .map(([value, label]) => ({ value, label }))
        .sort((a, b) => a.label.localeCompare(b.label));
}
/** File type options, present-types-only (E2E-24). Shared because every surface has this column. */
export function buildFileTypeOptions(rows) {
    return uniqueOptions(rows, (row) => row.typeFilterValue, (row) => row.typeLabel);
}
